import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import WifiOffIcon from '@mui/icons-material/WifiOff';

export default function OfflineNotification() {
  const { t } = useTranslation();
  const [showOfflineNotification, setShowOfflineNotification] = useState(false);

  // Monitor online/offline status
  useEffect(() => {
    const handleOnline = () => {
      // Hide notification after 3 seconds when connection is restored
      setTimeout(() => setShowOfflineNotification(false), 3000);
    };
    const handleOffline = () => {
      setShowOfflineNotification(true);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (!showOfflineNotification) {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        backgroundColor: '#ff4444',
        color: 'white',
        padding: '12px 16px',
        textAlign: 'center',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        fontSize: '16px',
        fontWeight: '500',
      }}
    >
      <WifiOffIcon style={{ fontSize: '20px' }} />
      {t('noInternetConnection')}
    </div>
  );
}
